import { SERVER_URI } from '../Constant/server'
import { apiGet, apiPost, apiPost1, apiPut, apiPut1 } from '../utils/axios'

const SAVE_PARTY_MENU = SERVER_URI + '/party/add-partymenu';
const GET_PARTY_MANU = SERVER_URI + '/party/get-partymenu/';
const UPDATE_STATUS = SERVER_URI + '/party/change-partymenu-status/';
const UPDATE_MENU_DATA = SERVER_URI + '/party/update-partymenu/';

export default {
    savePartyMenu: async function (paylaod) {
        return apiPost1(SAVE_PARTY_MENU, paylaod);
    },
    getPartyMenu: async function (id) {
        return apiGet(GET_PARTY_MANU + id);
    },
    UpdateMenuStatus: async function (id) {
        return apiGet(UPDATE_STATUS + id)
    },
   updateMenuData: async function (id, payload) {
        return apiPut1(UPDATE_MENU_DATA + id, payload)
    },
}

